import { arrayOf, shape, string, bool } from 'prop-types';
import React, { useState } from 'react';

import LegacyLinkClickAction from '@/components/ClickAction/legacy/LegacyUrlClickAction';
import { PortableText } from '@/components/PortableText/PortableText';
import PrimaryButton, {
  VARIANTS as BUTTON_VARIANTS,
} from '@/components/PrimaryButton';
import ShowMore from '@/components/ShowMore';
import IconBedRoom, {
  COLORS,
  SIZES,
} from '@/components/assets/IconBedRoom/IconBedRoom';
import IconCompletionDate from '@/components/assets/IconCompletionDate/IconCompletionDate';
import IconEuroSymbol from '@/components/assets/IconEuroSymbol/IconEuroSymbol';
import IconProperties from '@/components/assets/IconProperties/IconProperties';
import getVariantPrice from '@/helpers/getVariantPrice/getVariantPrice';

import { Text } from '../../../../module/Text';
import FeatureItem from '../FeatureItem';

import styles from './FeatureCard.module.scss';

const getFeatureData = (data) => {
  return [
    {
      icon: <IconEuroSymbol />,
      title: 'Pricing',
      text: getVariantPrice(data.pricing),
    },
    {
      icon: <IconBedRoom color={COLORS.DARK_PINK} size={SIZES.LARGE} />,
      title: 'Bedrooms',
      text: data.bedrooms,
    },
    {
      icon: <IconProperties />,
      title: 'Development size',
      text: data.developmentSize,
    },
    {
      icon: <IconCompletionDate />,
      title: 'Estimated launch',
      text: data.estimatedCompletion,
    },
  ];
};

const FeatureCard = (props) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const {
    title,
    featureInfo,
    text,
    downloadLink,
    uTour,
    pageType,
    page,
    showFirstButton,
    showSecondButton,
    firstButton,
    secondButton,
    clickAction1,
    clickAction2,
  } = props;

  const handleShowMoreClick = () => {
    setIsDropdownOpen((state) => !state);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
      </div>
      <div className={styles.container}>
        <div className={styles.grid}>
          {getFeatureData(featureInfo).map((item) => (
            <div className={styles.gridItem} key={item.title}>
              <FeatureItem data={item} />
            </div>
          ))}
        </div>
      </div>

      {text && text.length > 0 && (
        <div className={styles.info}>
          <div className={styles.button}>
            <ShowMore isActive={isDropdownOpen} onClick={handleShowMoreClick} />
          </div>
          {isDropdownOpen && (
            <div className={styles.moreContent}>
              <Text className={styles.markdown}>
                <PortableText content={text} />
              </Text>
            </div>
          )}
        </div>
      )}
      <div className={styles.buttonsWrapper}>
        {showFirstButton && (
          <div className={styles.ctaButton}>
            <LegacyLinkClickAction
              action={clickAction1}
              url={uTour}
              section="Key development details"
            >
              <div className={styles.button}>
                <PrimaryButton as="span" variant={BUTTON_VARIANTS.DARK}>
                  {firstButton}
                </PrimaryButton>
              </div>
            </LegacyLinkClickAction>
          </div>
        )}

        {showSecondButton && (
          <LegacyLinkClickAction
            action={clickAction2}
            url={downloadLink}
            section="Key development details"
          >
            <div className={styles.button}>
              <PrimaryButton as="span" variant={BUTTON_VARIANTS.TRANSPARENT_DARK}>
                {secondButton}
              </PrimaryButton>
            </div>
          </LegacyLinkClickAction>
        )}
      </div>
    </div>
  );
};

FeatureCard.propTypes = {
  title: string,
  featureInfo: shape({}),
  downloadLink: string,
  text: arrayOf(shape({})),
  uTour: string,
  pageType: string,
  page: string,
  showFirstButton: bool,
  showSecondButton: bool,
  firstButton: string,
  secondButton: string,
  clickAction1: shape({}),
  clickAction2: shape({}),
};

FeatureCard.defaultProps = {
  title: '',
  featureInfo: {},
  downloadLink: '',
  text: [],
  uTour: '',
  pageType: '',
  page: '',
  showFirstButton: false,
  showSecondButton: false,
  firstButton: 'Schedule a viewing',
  secondButton: 'Download brochure',
  clickAction1: {},
  clickAction2: {},
};

export default FeatureCard;
